export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref4727.f42de675.jpg";